export default {
  required: 'Ce champ est obligatoire',
  email: 'Veuillez entrer une adresse e-mail valide',
  minLength: 'Ce champ doit contenir au moins {min} caractères',
  maxLength: 'Ce champ ne doit pas dépasser {max} caractères',
  min: 'Ce champ doit être supérieur à {min}',
  max: 'Ce champ doit être inférieur à {max}',
  numeric: 'Ce champ doit être numérique',
  integer: 'Ce champ doit être un nombre entier',
  decimal: 'Ce champ doit être un nombre décimal',
  url: 'Veuillez entrer une URL valide',
  alpha: 'Ce champ ne doit contenir que des lettres',
  alphaNum: 'Ce champ ne doit contenir que des lettres et des chiffres',
  alphaDash: 'Ce champ ne doit contenir que des lettres, des chiffres, des tirets et des underscores',
  alphaSpaces: 'Ce champ ne doit contenir que des lettres et des espaces',
  in: 'Ce champ doit être l\'une des valeurs suivantes : {values}',
  notIn: 'Ce champ ne doit pas être l\'une des valeurs suivantes : {values}',
  confirmed: 'Ce champ ne correspond pas à la confirmation',
  different: 'Ce champ doit être différent de {field}',
  same: 'Ce champ doit être identique à {field}',
  between: 'Ce champ doit être compris entre {min} et {max}',
  before: 'Ce champ doit être antérieur à {date}',
  after: 'Ce champ doit être postérieur à {date}',
  dateFormat: 'Ce champ doit correspondre au format {format}',
  date: 'Ce champ doit être une date valide',
  boolean: 'Ce champ doit être un booléen',
  object: 'Ce champ doit être un objet',
  array: 'Ce champ doit être un tableau',
  string: 'Ce champ doit être une chaîne de caractères',
  number: 'Ce champ doit être un nombre',
  regex: 'Ce champ a un format invalide',
  digits: 'Ce champ ne doit contenir que des chiffres',
  creditCard: 'Ce champ doit être un numéro de carte de crédit valide',
  isbn: 'Ce champ doit être un ISBN valide',
  phone: 'Ce champ doit être un numéro de téléphone valide',
  postalCode: 'Ce champ doit être un code postal valide',
  ip: 'Ce champ doit être une adresse IP valide',
  ipv4: 'Ce champ doit être une adresse IPv4 valide',
  ipv6: 'Ce champ doit être une adresse IPv6 valide',
  macAddress: 'Ce champ doit être une adresse MAC valide',
  uuid: 'Ce champ doit être un UUID valide',
  ascii: 'Ce champ ne doit contenir que des caractères ASCII',
  base64: 'Ce champ doit être une chaîne Base64 valide',
  byteLength: 'Ce champ doit avoir une longueur comprise entre {min} et {max} octets',
  dataUri: 'Ce champ doit être un URI de données valide',
  mimeType: 'Ce champ doit être un type MIME valide',
  ext: 'Ce champ doit être l\'un des types de fichiers suivants : {extensions}',
  fileSize: 'Ce champ doit avoir une taille comprise entre {min} et {max}',
  image: 'Ce champ doit être un fichier image valide',
  video: 'Ce champ doit être un fichier vidéo valide',
  audio: 'Ce champ doit être un fichier audio valide',
  dimensions: 'Ce champ doit être une image de {width}x{height} pixels',
  fieldNames: {
    username: 'Nom d\'utilisateur',
    email: 'Adresse e-mail',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    firstName: 'Prénom',
    lastName: 'Nom',
    phone: 'Téléphone',
    address: 'Adresse',
    city: 'Ville',
    state: 'État/Région',
    country: 'Pays',
    postalCode: 'Code postal',
    website: 'Site web',
    description: 'Description',
    title: 'Titre',
    content: 'Contenu',
    category: 'Catégorie',
    tags: 'Tags',
    price: 'Prix',
    quantity: 'Quantité',
    rating: 'Note',
    comment: 'Commentaire',
    search: 'Recherche',
    message: 'Message',
    subject: 'Sujet',
    name: 'Nom',
    company: 'Entreprise',
    position: 'Poste',
    department: 'Département',
    birthday: 'Date de naissance',
    gender: 'Genre',
    language: 'Langue',
    timezone: 'Fuseau horaire',
    currency: 'Devise',
    paymentMethod: 'Mode de paiement',
    cardNumber: 'Numéro de carte',
    cardExpiry: 'Date d\'expiration',
    cardCvv: 'Code de sécurité',
    terms: 'Conditions',
    privacy: 'Confidentialité',
    newsletter: 'Newsletter',
    notifications: 'Notifications',
    avatar: 'Avatar',
    bio: 'Biographie',
    social: 'Réseaux sociaux',
    preferences: 'Préférences'
  }
}; 